// NotFoundPage.tsx
import React from "react";
import "../../styles/notFound.css"; // Import CSS file for styling

const NotFoundPage: React.FC = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">
          Oops! A página que está a tentar aceder não existe.
        </p>
        <a href="/Dashboard" className="notfound-link">
          Regressar ao Dashboard
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
